var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4c7a2b0b9fa5bf696b9751de17a4dd6f9efe44f5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["engine-frontend@apollograph"]={id:"4c7a2b0b9fa5bf696b9751de17a4dd6f9efe44f5"};
      